export default __webpack_public_path__ + "static/media/771.131ab546.png";